module.exports = __webpack_public_path__ + "img/alquiler-camiones.b90256ae.png";